export const tcc_json = [
  {
    "reg": "PAC",
    "region": "Pacific Ocean",
    "total": 40,
    "db": [
      {
        "id": "PF-A",
        "int_id": 1260,
        "unp": "PF",
        "un": "FR",
        "name": "Austral Islands",
        "short_name": "Austral Islands",
        "rareness": 1,
        "visitors": 3
      },
      {
        "id": "AU:0",
        "int_id": 1274,
        "unp": "AU",
        "un": "AU",
        "name": "Australia",
        "short_name": "Australia",
        "rareness": 7,
        "visitors": 2526
      },
      {
        "id": "PG:I",
        "int_id": 1275,
        "unp": "PG",
        "un": "PG",
        "name": "Bismarck Archipelago (Admiralty Islands, Bougainville, New Britain, New Ireland)",
        "short_name": "Bismarck Archipelago",
        "rareness": 1,
        "visitors": 9
      },
      {
        "id": "NZ-CIT",
        "int_id": 992,
        "unp": "NZ",
        "un": "NZ",
        "name": "Chatham Islands",
        "short_name": "Chatham Islands",
        "rareness": 1,
        "visitors": 1
      },
      {
        "id": "CK",
        "int_id": 55,
        "unp": "CK",
        "un": "NZ",
        "name": "Cook Islands (Aitutaki, Penrhyn, Rarotonga)",
        "short_name": "Cook Islands",
        "rareness": 3,
        "visitors": 50
      },
      {
        "id": "CL-VS:1",
        "int_id": 736,
        "unp": "CL",
        "un": "CL",
        "name": "Easter Island",
        "short_name": "Easter Island",
        "rareness": 3,
        "visitors": 65
      },
      {
        "id": "FJ",
        "int_id": 77,
        "unp": "FJ",
        "un": "FJ",
        "name": "Fiji Islands",
        "short_name": "Fiji Islands",
        "rareness": 5,
        "visitors": 323
      },
      {
        "id": "PF",
        "int_id": 81,
        "unp": "PF",
        "un": "FR",
        "name": "French Polynesia (Gambier, Tahiti, Tuamotu)",
        "short_name": "French Polynesia",
        "rareness": 4,
        "visitors": 149
      },
      {
        "id": "EC-W",
        "int_id": 636,
        "unp": "EC",
        "un": "EC",
        "name": "Galapagos Islands",
        "short_name": "Galapagos Islands",
        "rareness": 4,
        "visitors": 118
      },
      {
        "id": "GU",
        "int_id": 93,
        "unp": "GU",
        "un": "US",
        "name": "Guam",
        "short_name": "Guam",
        "rareness": 4,
        "visitors": 126
      },
      {
        "id": "US-HI",
        "int_id": 538,
        "unp": "US",
        "un": "US",
        "name": "Hawaiian Islands",
        "short_name": "Hawaiian Islands",
        "rareness": 6,
        "visitors": 1604
      },
      {
        "id": "CL-VS:2",
        "int_id": 735,
        "unp": "CL",
        "un": "CL",
        "name": "Juan Fernandez Islands (Robinson Crusoe Island)",
        "short_name": "Juan Fernandez Islands",
        "rareness": 1,
        "visitors": 2
      },
      {
        "id": "KI:1",
        "int_id": 1276,
        "unp": "KI",
        "un": "KI",
        "name": "Kiribati (Gilberts, Tarawa, Ocean Island)",
        "short_name": "Kiribati",
        "rareness": 1,
        "visitors": 6
      },
      {
        "id": "KI:2",
        "int_id": 1277,
        "unp": "KI",
        "un": "KI",
        "name": "Line/Phoenix Islands (Canton, Christmas, Enderbury, Fanning)",
        "short_name": "Line/Phoenix Islands",
        "rareness": 1,
        "visitors": 7
      },
      {
        "id": "AU:LDH",
        "int_id": 1278,
        "unp": "AU",
        "un": "AU",
        "name": "Lord Howe Island",
        "short_name": "Lord Howe Island",
        "rareness": 1,
        "visitors": 3
      },
      {
        "id": "PF-M",
        "int_id": 1257,
        "unp": "PF",
        "un": "FR",
        "name": "Marquesas Islands",
        "short_name": "Marquesas Islands",
        "rareness": 1,
        "visitors": 9
      },
      {
        "id": "MH",
        "int_id": 142,
        "unp": "MH",
        "un": "MH",
        "name": "Marshall Islands, Republic of (Eniwetok, Kwajalein, Majuro)",
        "short_name": "Marshall Islands",
        "rareness": 2,
        "visitors": 16
      },
      {
        "id": "FM",
        "int_id": 148,
        "unp": "FM",
        "un": "FM",
        "name": "Micronesia, Fed.States of (Caroline Islands, Chuuk, Kosrae, Pohnpei, Yap)",
        "short_name": "Micronesia",
        "rareness": 2,
        "visitors": 21
      },
      {
        "id": "US-UM-71",
        "int_id": 1279,
        "unp": "UM",
        "un": "US",
        "name": "Midway Island",
        "short_name": "Midway Island",
        "rareness": 1,
        "visitors": 5
      },
      {
        "id": "NR",
        "int_id": 158,
        "unp": "NR",
        "un": "NR",
        "name": "Nauru",
        "short_name": "Nauru",
        "rareness": 1,
        "visitors": 7
      },
      {
        "id": "NC",
        "int_id": 161,
        "unp": "NC",
        "un": "FR",
        "name": "New Caledonia & Dependencies (L’Île-des-Pins, Loyalty Islands)",
        "short_name": "New Caledonia",
        "rareness": 4,
        "visitors": 119
      },
      {
        "id": "NZ:0",
        "int_id": 1280,
        "unp": "NZ",
        "un": "NZ",
        "name": "New Zealand",
        "short_name": "New Zealand",
        "rareness": 6,
        "visitors": 1202
      },
      {
        "id": "NU",
        "int_id": 166,
        "unp": "NU",
        "un": "NZ",
        "name": "Niue",
        "short_name": "Niue",
        "rareness": 1,
        "visitors": 3
      },
      {
        "id": "NF",
        "int_id": 167,
        "unp": "NF",
        "un": "AU",
        "name": "Norfolk Island",
        "short_name": "Norfolk Island",
        "rareness": 2,
        "visitors": 15
      },
      {
        "id": "MP",
        "int_id": 170,
        "unp": "MP",
        "un": "US",
        "name": "Northern Marianas (Saipan, Tinian)",
        "short_name": "Northern Marianas",
        "rareness": 3,
        "visitors": 39
      },
      {
        "id": "JP-13:1",
        "int_id": 816,
        "unp": "JP",
        "un": "JP",
        "name": "Ogasawara (Bonin, Iwo Jima, Volcano Island)",
        "short_name": "Ogasawara",
        "rareness": 1,
        "visitors": 3
      },
      {
        "id": "PW",
        "int_id": 174,
        "unp": "PW",
        "un": "PW",
        "name": "Palau, Republic of",
        "short_name": "Palau",
        "rareness": 2,
        "visitors": 30
      },
      {
        "id": "PG:0",
        "int_id": 1281,
        "unp": "PG",
        "un": "PG",
        "name": "Papua New Guinea",
        "short_name": "Papua New Guinea",
        "rareness": 3,
        "visitors": 67
      },
      {
        "id": "PN",
        "int_id": 181,
        "unp": "PN",
        "un": "GB",
        "name": "Pitcairn Island",
        "short_name": "Pitcairn Island",
        "rareness": 1,
        "visitors": 3
      },
      {
        "id": "JP-47",
        "int_id": 814,
        "unp": "JP",
        "un": "JP",
        "name": "Ryukyu Islands (Okinawa)",
        "short_name": "Ryukyu Islands",
        "rareness": 5,
        "visitors": 306
      },
      {
        "id": "WS",
        "int_id": 197,
        "unp": "WS",
        "un": "WS",
        "name": "Samoa",
        "short_name": "Samoa",
        "rareness": 3,
        "visitors": 60
      },
      {
        "id": "AS",
        "int_id": 7,
        "unp": "AS",
        "un": "US",
        "name": "Samoa, American",
        "short_name": "American Samoa",
        "rareness": 2,
        "visitors": 24
      },
      {
        "id": "SB",
        "int_id": 209,
        "unp": "SB",
        "un": "SB",
        "name": "Solomon Islands (Guadalcanal, New Georgia, Tulagi)",
        "short_name": "Solomon Islands",
        "rareness": 2,
        "visitors": 33
      },
      {
        "id": "AU-TAS",
        "int_id": 1094,
        "unp": "AU",
        "un": "AU",
        "name": "Tasmania",
        "short_name": "Tasmania",
        "rareness": 5,
        "visitors": 381
      },
      {
        "id": "TK",
        "int_id": 230,
        "unp": "TK",
        "un": "NZ",
        "name": "Tokelau Islands (Atafu, Fakaofu, Union)",
        "short_name": "Tokelau Islands",
        "rareness": 1,
        "visitors": 0
      },
      {
        "id": "TO",
        "int_id": 231,
        "unp": "TO",
        "un": "TO",
        "name": "Tonga (Nukualofa)",
        "short_name": "Tonga",
        "rareness": 3,
        "visitors": 47
      },
      {
        "id": "TV",
        "int_id": 238,
        "unp": "TV",
        "un": "TV",
        "name": "Tuvalu (Ellice Island, Funafuti, Vaitapu)",
        "short_name": "Tuvalu",
        "rareness": 1,
        "visitors": 5
      },
      {
        "id": "VU",
        "int_id": 247,
        "unp": "VU",
        "un": "VU",
        "name": "Vanuatu (New Hebrides Islands)",
        "short_name": "Vanuatu",
        "rareness": 4,
        "visitors": 117
      },
      {
        "id": "US-UM-79",
        "int_id": 1282,
        "unp": "UM",
        "un": "US",
        "name": "Wake Island",
        "short_name": "Wake Island",
        "rareness": 1,
        "visitors": 6
      },
      {
        "id": "WF",
        "int_id": 252,
        "unp": "WF",
        "un": "FR",
        "name": "Wallis & Futuna Islands",
        "short_name": "Wallis & Futuna Islands",
        "rareness": 1,
        "visitors": 4
      }
    ]
  },
  {
    "reg": "NAM",
    "region": "North America",
    "total": 6,
    "db": [
      {
        "id": "US-AK",
        "int_id": 537,
        "unp": "US",
        "un": "US",
        "name": "Alaska",
        "short_name": "Alaska",
        "rareness": 6,
        "visitors": 912
      },
      {
        "id": "CA:0",
        "int_id": 1283,
        "unp": "CA",
        "un": "CA",
        "name": "Canada",
        "short_name": "Canada",
        "rareness": 7,
        "visitors": 5400
      },
      {
        "id": "MX",
        "int_id": 147,
        "unp": "MX",
        "un": "MX",
        "name": "Mexico",
        "short_name": "Mexico",
        "rareness": 7,
        "visitors": 3914
      },
      {
        "id": "CA-PE",
        "int_id": 546,
        "unp": "CA",
        "un": "CA",
        "name": "Prince Edward Island",
        "short_name": "Prince Edward Island",
        "rareness": 5,
        "visitors": 286
      },
      {
        "id": "PM",
        "int_id": 195,
        "unp": "PM",
        "un": "FR",
        "name": "St. Pierre & Miquelon",
        "short_name": "St. Pierre & Miquelon",
        "rareness": 2,
        "visitors": 16
      },
      {
        "id": "US:0",
        "int_id": 1284,
        "unp": "US",
        "un": "US",
        "name": "United States (Contiguous)",
        "short_name": "United States",
        "rareness": 7,
        "visitors": 11263
      }
    ]
  },
  {
    "reg": "CAM",
    "region": "Central America",
    "total": 7,
    "db": [
      {
        "id": "BZ",
        "int_id": 25,
        "unp": "BZ",
        "un": "BZ",
        "name": "Belize",
        "short_name": "Belize",
        "rareness": 6,
        "visitors": 541
      },
      {
        "id": "CR",
        "int_id": 56,
        "unp": "CR",
        "un": "CR",
        "name": "Costa Rica",
        "short_name": "Costa Rica",
        "rareness": 6,
        "visitors": 998
      },
      {
        "id": "SV",
        "int_id": 69,
        "unp": "SV",
        "un": "SV",
        "name": "El Salvador",
        "short_name": "El Salvador",
        "rareness": 5,
        "visitors": 225
      },
      {
        "id": "GT",
        "int_id": 94,
        "unp": "GT",
        "un": "GT",
        "name": "Guatemala",
        "short_name": "Guatemala",
        "rareness": 5,
        "visitors": 453
      },
      {
        "id": "HN",
        "int_id": 102,
        "unp": "HN",
        "un": "HN",
        "name": "Honduras",
        "short_name": "Honduras",
        "rareness": 5,
        "visitors": 422
      },
      {
        "id": "NI",
        "int_id": 163,
        "unp": "NI",
        "un": "NI",
        "name": "Nicaragua",
        "short_name": "Nicaragua",
        "rareness": 4,
        "visitors": 211
      },
      {
        "id": "PA",
        "int_id": 176,
        "unp": "PA",
        "un": "PA",
        "name": "Panama",
        "short_name": "Panama",
        "rareness": 6,
        "visitors": 715
      }
    ]
  },
  {
    "reg": "SAM",
    "region": "South America",
    "total": 14,
    "db": [
      {
        "id": "AR",
        "int_id": 13,
        "unp": "AR",
        "un": "AR",
        "name": "Argentina",
        "short_name": "Argentina",
        "rareness": 6,
        "visitors": 1391
      },
      {
        "id": "BO",
        "int_id": 29,
        "unp": "BO",
        "un": "BO",
        "name": "Bolivia",
        "short_name": "Bolivia",
        "rareness": 5,
        "visitors": 373
      },
      {
        "id": "BR:0",
        "int_id": 1285,
        "unp": "BR",
        "un": "BR",
        "name": "Brazil",
        "short_name": "Brazil",
        "rareness": 6,
        "visitors": 1729
      },
      {
        "id": "CL:0",
        "int_id": 1286,
        "unp": "CL",
        "un": "CL",
        "name": "Chile",
        "short_name": "Chile",
        "rareness": 6,
        "visitors": 974
      },
      {
        "id": "CO:0",
        "int_id": 1287,
        "unp": "CO",
        "un": "CO",
        "name": "Colombia",
        "short_name": "Colombia",
        "rareness": 6,
        "visitors": 1019
      },
      {
        "id": "EC:0",
        "int_id": 1288,
        "unp": "EC",
        "un": "EC",
        "name": "Ecuador",
        "short_name": "Ecuador",
        "rareness": 5,
        "visitors": 461
      },
      {
        "id": "GF",
        "int_id": 80,
        "unp": "GF",
        "un": "FR",
        "name": "French Guiana",
        "short_name": "French Guiana",
        "rareness": 3,
        "visitors": 56
      },
      {
        "id": "GY",
        "int_id": 98,
        "unp": "GY",
        "un": "GY",
        "name": "Guyana",
        "short_name": "Guyana",
        "rareness": 3,
        "visitors": 52
      },
      {
        "id": "VE-O",
        "int_id": 1289,
        "unp": "VE",
        "un": "VE",
        "name": "Nueva Esparta (Margarita Island)",
        "short_name": "Nueva Esparta",
        "rareness": 3,
        "visitors": 57
      },
      {
        "id": "PY",
        "int_id": 178,
        "unp": "PY",
        "un": "PY",
        "name": "Paraguay",
        "short_name": "Paraguay",
        "rareness": 5,
        "visitors": 331
      },
      {
        "id": "PE",
        "int_id": 179,
        "unp": "PE",
        "un": "PE",
        "name": "Peru",
        "short_name": "Peru",
        "rareness": 6,
        "visitors": 1040
      },
      {
        "id": "SR",
        "int_id": 219,
        "unp": "SR",
        "un": "SR",
        "name": "Suriname",
        "short_name": "Suriname",
        "rareness": 3,
        "visitors": 56
      },
      {
        "id": "UY",
        "int_id": 245,
        "unp": "UY",
        "un": "UY",
        "name": "Uruguay",
        "short_name": "Uruguay",
        "rareness": 6,
        "visitors": 646
      },
      {
        "id": "VE:0",
        "int_id": 1290,
        "unp": "VE",
        "un": "VE",
        "name": "Venezuela",
        "short_name": "Venezuela",
        "rareness": 5,
        "visitors": 250
      }
    ]
  },
  {
    "reg": "CRB",
    "region": "Caribbean",
    "total": 31,
    "db": [
      {
        "id": "AI",
        "int_id": 10,
        "unp": "AI",
        "un": "GB",
        "name": "Anguilla",
        "short_name": "Anguilla",
        "rareness": 4,
        "visitors": 75
      },
      {
        "id": "AG",
        "int_id": 12,
        "unp": "AG",
        "un": "AG",
        "name": "Antigua & Barbuda",
        "short_name": "Antigua & Barbuda",
        "rareness": 5,
        "visitors": 268
      },
      {
        "id": "AW",
        "int_id": 15,
        "unp": "AW",
        "un": "NL",
        "name": "Aruba",
        "short_name": "Aruba",
        "rareness": 5,
        "visitors": 449
      },
      {
        "id": "BS",
        "int_id": 19,
        "unp": "BS",
        "un": "BS",
        "name": "Bahamas",
        "short_name": "Bahamas",
        "rareness": 6,
        "visitors": 1327
      },
      {
        "id": "BB",
        "int_id": 22,
        "unp": "BB",
        "un": "BB",
        "name": "Barbados",
        "short_name": "Barbados",
        "rareness": 5,
        "visitors": 397
      },
      {
        "id": "BQ-BO",
        "int_id": 1096,
        "unp": "BQ",
        "un": "NL",
        "name": "Bonaire",
        "short_name": "Bonaire",
        "rareness": 4,
        "visitors": 112
      },
      {
        "id": "KY",
        "int_id": 44,
        "unp": "KY",
        "un": "GB",
        "name": "Cayman Islands",
        "short_name": "Cayman Islands",
        "rareness": 5,
        "visitors": 443
      },
      {
        "id": "CU",
        "int_id": 59,
        "unp": "CU",
        "un": "CU",
        "name": "Cuba",
        "short_name": "Cuba",
        "rareness": 6,
        "visitors": 818
      },
      {
        "id": "CW",
        "int_id": 60,
        "unp": "CW",
        "un": "NL",
        "name": "Curacao",
        "short_name": "Curacao",
        "rareness": 5,
        "visitors": 309
      },
      {
        "id": "DM",
        "int_id": 65,
        "unp": "DM",
        "un": "DM",
        "name": "Dominica",
        "short_name": "Dominica",
        "rareness": 4,
        "visitors": 141
      },
      {
        "id": "DO",
        "int_id": 66,
        "unp": "DO",
        "un": "DO",
        "name": "Dominican Republic",
        "short_name": "Dominican Republic",
        "rareness": 6,
        "visitors": 1067
      },
      {
        "id": "GD",
        "int_id": 91,
        "unp": "GD",
        "un": "GD",
        "name": "Grenada & Dependencies (Carriacou, Grenadines)",
        "short_name": "Grenada",
        "rareness": 4,
        "visitors": 174
      },
      {
        "id": "GP",
        "int_id": 92,
        "unp": "GP",
        "un": "FR",
        "name": "Guadeloupe & Dependencies (Marie Galante)",
        "short_name": "Guadeloupe",
        "rareness": 4,
        "visitors": 171
      },
      {
        "id": "HT",
        "int_id": 99,
        "unp": "HT",
        "un": "HT",
        "name": "Haiti",
        "short_name": "Haiti",
        "rareness": 4,
        "visitors": 212
      },
      {
        "id": "JM",
        "int_id": 114,
        "unp": "JM",
        "un": "JM",
        "name": "Jamaica",
        "short_name": "Jamaica",
        "rareness": 6,
        "visitors": 853
      },
      {
        "id": "MQ",
        "int_id": 143,
        "unp": "MQ",
        "un": "FR",
        "name": "Martinique",
        "short_name": "Martinique",
        "rareness": 4,
        "visitors": 224
      },
      {
        "id": "MS",
        "int_id": 153,
        "unp": "MS",
        "un": "GB",
        "name": "Montserrat",
        "short_name": "Montserrat",
        "rareness": 2,
        "visitors": 29
      },
      {
        "id": "KN-N",
        "int_id": 1247,
        "unp": "KN",
        "un": "KN",
        "name": "Nevis",
        "short_name": "Nevis",
        "rareness": 3,
        "visitors": 57
      },
      {
        "id": "PR",
        "int_id": 184,
        "unp": "PR",
        "un": "US",
        "name": "Puerto Rico",
        "short_name": "Puerto Rico",
        "rareness": 6,
        "visitors": 986
      },
      {
        "id": "BQ:SSE",
        "int_id": 1291,
        "unp": "BQ",
        "un": "NL",
        "name": "Saba & Sint Eustatius",
        "short_name": "Saba & Sint Eustatius",
        "rareness": 3,
        "visitors": 45
      },
      {
        "id": "CO-SAP",
        "int_id": 870,
        "unp": "CO",
        "un": "CO",
        "name": "San Andres & Providencia",
        "short_name": "San Andres & Providencia",
        "rareness": 3,
        "visitors": 65
      },
      {
        "id": "SX",
        "int_id": 206,
        "unp": "SX",
        "un": "NL",
        "name": "Sint Maarten (Netherlands)",
        "short_name": "Sint Maarten",
        "rareness": 5,
        "visitors": 364
      },
      {
        "id": "BL",
        "int_id": 190,
        "unp": "BL",
        "un": "FR",
        "name": "St. Barthélemy",
        "short_name": "St. Barthélemy",
        "rareness": 3,
        "visitors": 65
      },
      {
        "id": "KN-K",
        "int_id": 1246,
        "unp": "KN",
        "un": "KN",
        "name": "St. Kitts",
        "short_name": "St. Kitts",
        "rareness": 4,
        "visitors": 218
      },
      {
        "id": "LC",
        "int_id": 193,
        "unp": "LC",
        "un": "LC",
        "name": "St. Lucia",
        "short_name": "St. Lucia",
        "rareness": 5,
        "visitors": 340
      },
      {
        "id": "MF",
        "int_id": 194,
        "unp": "MF",
        "un": "FR",
        "name": "St. Martin (France)",
        "short_name": "St. Martin",
        "rareness": 5,
        "visitors": 261
      },
      {
        "id": "VC",
        "int_id": 196,
        "unp": "VC",
        "un": "VC",
        "name": "St. Vincent & the Grenadines",
        "short_name": "St. Vincent & the Grenadines",
        "rareness": 4,
        "visitors": 125
      },
      {
        "id": "TT",
        "int_id": 233,
        "unp": "TT",
        "un": "TT",
        "name": "Trinidad & Tobago",
        "short_name": "Trinidad & Tobago",
        "rareness": 4,
        "visitors": 168
      },
      {
        "id": "TC",
        "int_id": 237,
        "unp": "TC",
        "un": "GB",
        "name": "Turks & Caicos Islands",
        "short_name": "Turks & Caicos Islands",
        "rareness": 5,
        "visitors": 231
      },
      {
        "id": "VG",
        "int_id": 250,
        "unp": "VG",
        "un": "GB",
        "name": "Virgin Islands, British (Tortola, etc.)",
        "short_name": "British Virgin Islands",
        "rareness": 4,
        "visitors": 207
      },
      {
        "id": "VI",
        "int_id": 251,
        "unp": "VI",
        "un": "US",
        "name": "Virgin Islands, U.S. (St. Croix, St. John, St. Thomas)",
        "short_name": "U.S. Virgin Islands",
        "rareness": 6,
        "visitors": 482
      }
    ]
  },
  {
    "reg": "ATL",
    "region": "Atlantic Ocean",
    "total": 14,
    "db": [
      {
        "id": "SH-AC",
        "int_id": 707,
        "unp": "SH",
        "un": "GB",
        "name": "Ascension",
        "short_name": "Ascension",
        "rareness": 1,
        "visitors": 9
      },
      {
        "id": "PT-20",
        "int_id": 910,
        "unp": "PT",
        "un": "PT",
        "name": "Azores Islands",
        "short_name": "Azores Islands",
        "rareness": 5,
        "visitors": 312
      },
      {
        "id": "BM",
        "int_id": 27,
        "unp": "BM",
        "un": "GB",
        "name": "Bermuda",
        "short_name": "Bermuda",
        "rareness": 4,
        "visitors": 205
      },
      {
        "id": "ES-CN",
        "int_id": 833,
        "unp": "ES",
        "un": "ES",
        "name": "Canary Islands",
        "short_name": "Canary Islands",
        "rareness": 6,
        "visitors": 1712
      },
      {
        "id": "CV",
        "int_id": 40,
        "unp": "CV",
        "un": "CV",
        "name": "Cape Verde Islands",
        "short_name": "Cape Verde Islands",
        "rareness": 4,
        "visitors": 185
      },
      {
        "id": "FK",
        "int_id": 75,
        "unp": "FK",
        "un": "GB",
        "name": "Falkland Islands",
        "short_name": "Falkland Islands",
        "rareness": 3,
        "visitors": 54
      },
      {
        "id": "FO",
        "int_id": 76,
        "unp": "FO",
        "un": "DK",
        "name": "Faroe Islands",
        "short_name": "Faroe Islands",
        "rareness": 4,
        "visitors": 113
      },
      {
        "id": "BR-PE:1",
        "int_id": 473,
        "unp": "BR",
        "un": "BR",
        "name": "Fernando de Noronha",
        "short_name": "Fernando de Noronha",
        "rareness": 2,
        "visitors": 29
      },
      {
        "id": "GL",
        "int_id": 90,
        "unp": "GL",
        "un": "DK",
        "name": "Greenland (Kalaallit Nunaat)",
        "short_name": "Greenland",
        "rareness": 4,
        "visitors": 76
      },
      {
        "id": "IS",
        "int_id": 105,
        "unp": "IS",
        "un": "IS",
        "name": "Iceland",
        "short_name": "Iceland",
        "rareness": 6,
        "visitors": 1464
      },
      {
        "id": "PT-30",
        "int_id": 909,
        "unp": "PT",
        "un": "PT",
        "name": "Madeira",
        "short_name": "Madeira",
        "rareness": 6,
        "visitors": 500
      },
      {
        "id": "GS",
        "int_id": 213,
        "unp": "GS",
        "un": "GB",
        "name": "South Georgia & the South Sandwich Islands",
        "short_name": "South Georgia & the South Sandwich Islands",
        "rareness": 2,
        "visitors": 11
      },
      {
        "id": "SH-HL",
        "int_id": 706,
        "unp": "SH",
        "un": "GB",
        "name": "St. Helena",
        "short_name": "St. Helena",
        "rareness": 2,
        "visitors": 9
      },
      {
        "id": "SH-TA",
        "int_id": 708,
        "unp": "SH",
        "un": "GB",
        "name": "Tristan da Cunha",
        "short_name": "Tristan da Cunha",
        "rareness": 1,
        "visitors": 4
      }
    ]
  },
  {
    "reg": "EUR",
    "region": "Europe and Mediterranean",
    "total": 68,
    "db": [
      {
        "id": "AX",
        "int_id": 4,
        "unp": "AX",
        "un": "FI",
        "name": "Aland Islands",
        "short_name": "Aland Islands",
        "rareness": 4,
        "visitors": 150
      },
      {
        "id": "AL",
        "int_id": 5,
        "unp": "AL",
        "un": "AL",
        "name": "Albania",
        "short_name": "Albania",
        "rareness": 6,
        "visitors": 955
      },
      {
        "id": "AD",
        "int_id": 8,
        "unp": "AD",
        "un": "AD",
        "name": "Andorra",
        "short_name": "Andorra",
        "rareness": 6,
        "visitors": 850
      },
      {
        "id": "AT",
        "int_id": 17,
        "unp": "AT",
        "un": "AT",
        "name": "Austria",
        "short_name": "Austria",
        "rareness": 7,
        "visitors": 6520
      },
      {
        "id": "ES-IB",
        "int_id": 817,
        "unp": "ES",
        "un": "ES",
        "name": "Balearic Islands (Ibiza, Mallorca, Minorca)",
        "short_name": "Balearic Islands",
        "rareness": 7,
        "visitors": 2149
      },
      {
        "id": "BY",
        "int_id": 23,
        "unp": "BY",
        "un": "BY",
        "name": "Belarus",
        "short_name": "Belarus",
        "rareness": 6,
        "visitors": 819
      },
      {
        "id": "BE",
        "int_id": 24,
        "unp": "BE",
        "un": "BE",
        "name": "Belgium",
        "short_name": "Belgium",
        "rareness": 7,
        "visitors": 5681
      },
      {
        "id": "BA:0",
        "int_id": 1292,
        "unp": "BA",
        "un": "BA",
        "name": "Bosnia & Herzegovina",
        "short_name": "Bosnia & Herzegovina",
        "rareness": 6,
        "visitors": 1375
      },
      {
        "id": "BG",
        "int_id": 37,
        "unp": "BG",
        "un": "BG",
        "name": "Bulgaria",
        "short_name": "Bulgaria",
        "rareness": 7,
        "visitors": 1906
      },
      {
        "id": "FR-20R",
        "int_id": 1293,
        "unp": "FR",
        "un": "FR",
        "name": "Corsica",
        "short_name": "Corsica",
        "rareness": 6,
        "visitors": 498
      },
      {
        "id": "GR-M",
        "int_id": 791,
        "unp": "GR",
        "un": "GR",
        "name": "Crete",
        "short_name": "Crete",
        "rareness": 6,
        "visitors": 1413
      },
      {
        "id": "HR",
        "int_id": 58,
        "unp": "HR",
        "un": "HR",
        "name": "Croatia",
        "short_name": "Croatia",
        "rareness": 7,
        "visitors": 3590
      },
      {
        "id": "XD",
        "int_id": 3,
        "unp": "XD",
        "un": "GB",
        "name": "Cyprus, British Sovereign Base Areas of Akrotiri & Dhekelia",
        "short_name": "Cyprus, British Sovereign Base Areas of Akrotiri & Dhekelia",
        "rareness": 3,
        "visitors": 53
      },
      {
        "id": "CY",
        "int_id": 61,
        "unp": "CY",
        "un": "CY",
        "name": "Cyprus, Republic",
        "short_name": "Cyprus, Republic",
        "rareness": 6,
        "visitors": 1342
      },
      {
        "id": "XC",
        "int_id": 169,
        "unp": "XC",
        "un": "CY",
        "name": "Cyprus, Turkish Fed. State",
        "short_name": "Cyprus, Turkish Fed. State",
        "rareness": 5,
        "visitors": 449
      },
      {
        "id": "CZ",
        "int_id": 62,
        "unp": "CZ",
        "un": "CZ",
        "name": "Czech Republic",
        "short_name": "Czech Republic",
        "rareness": 7,
        "visitors": 5547
      },
      {
        "id": "DK",
        "int_id": 63,
        "unp": "DK",
        "un": "DK",
        "name": "Denmark",
        "short_name": "Denmark",
        "rareness": 7,
        "visitors": 3804
      },
      {
        "id": "GB-ENG",
        "int_id": 1294,
        "unp": "GB",
        "un": "GB",
        "name": "England",
        "short_name": "England",
        "rareness": 7,
        "visitors": 8994
      },
      {
        "id": "EE",
        "int_id": 72,
        "unp": "EE",
        "un": "EE",
        "name": "Estonia",
        "short_name": "Estonia",
        "rareness": 7,
        "visitors": 1828
      },
      {
        "id": "FI",
        "int_id": 78,
        "unp": "FI",
        "un": "FI",
        "name": "Finland",
        "short_name": "Finland",
        "rareness": 7,
        "visitors": 2496
      },
      {
        "id": "FR:0",
        "int_id": 1295,
        "unp": "FR",
        "un": "FR",
        "name": "France",
        "short_name": "France",
        "rareness": 7,
        "visitors": 10236
      },
      {
        "id": "DE",
        "int_id": 86,
        "unp": "DE",
        "un": "DE",
        "name": "Germany",
        "short_name": "Germany",
        "rareness": 7,
        "visitors": 9234
      },
      {
        "id": "GI",
        "int_id": 88,
        "unp": "GI",
        "un": "GB",
        "name": "Gibraltar",
        "short_name": "Gibraltar",
        "rareness": 6,
        "visitors": 931
      },
      {
        "id": "GR:0",
        "int_id": 1296,
        "unp": "GR",
        "un": "GR",
        "name": "Greece",
        "short_name": "Greece",
        "rareness": 7,
        "visitors": 4025
      },
      {
        "id": "GR:A",
        "int_id": 1297,
        "unp": "GR",
        "un": "GR",
        "name": "Greek Aegean Islands (Cyclades, Dodecanese, Northern Aegean Islands)",
        "short_name": "Greek Aegean Islands",
        "rareness": 7,
        "visitors": 2261
      },
      {
        "id": "GG",
        "int_id": 95,
        "unp": "GG",
        "un": "GB",
        "name": "Guernsey & Dependencies (Alderney, Herm, Sark)",
        "short_name": "Guernsey",
        "rareness": 4,
        "visitors": 123
      },
      {
        "id": "HU",
        "int_id": 104,
        "unp": "HU",
        "un": "HU",
        "name": "Hungary",
        "short_name": "Hungary",
        "rareness": 7,
        "visitors": 4436
      },
      {
        "id": "GR-F",
        "int_id": 795,
        "unp": "GR",
        "un": "GR",
        "name": "Ionian Islands (Corfu, etc.)",
        "short_name": "Ionian Islands",
        "rareness": 6,
        "visitors": 1161
      },
      {
        "id": "IE",
        "int_id": 110,
        "unp": "IE",
        "un": "IE",
        "name": "Ireland (Eire)",
        "short_name": "Ireland",
        "rareness": 7,
        "visitors": 3383
      },
      {
        "id": "GB-NIR",
        "int_id": 289,
        "unp": "GB",
        "un": "GB",
        "name": "Ireland, Northern",
        "short_name": "Ireland, Northern",
        "rareness": 6,
        "visitors": 1238
      },
      {
        "id": "IM",
        "int_id": 111,
        "unp": "IM",
        "un": "GB",
        "name": "Isle of Man",
        "short_name": "Isle of Man",
        "rareness": 4,
        "visitors": 125
      },
      {
        "id": "IT:0",
        "int_id": 1298,
        "unp": "IT",
        "un": "IT",
        "name": "Italy",
        "short_name": "Italy",
        "rareness": 7,
        "visitors": 9687
      },
      {
        "id": "JE",
        "int_id": 116,
        "unp": "JE",
        "un": "GB",
        "name": "Jersey",
        "short_name": "Jersey",
        "rareness": 4,
        "visitors": 185
      },
      {
        "id": "RU-KGD",
        "int_id": 386,
        "unp": "RU",
        "un": "RU",
        "name": "Kaliningrad",
        "short_name": "Kaliningrad",
        "rareness": 5,
        "visitors": 435
      },
      {
        "id": "XK",
        "int_id": 123,
        "unp": "XK",
        "un": "RS",
        "name": "Kosovo",
        "short_name": "Kosovo",
        "rareness": 6,
        "visitors": 462
      },
      {
        "id": "IT:LMP",
        "int_id": 1299,
        "unp": "IT",
        "un": "IT",
        "name": "Lampedusa",
        "short_name": "Lampedusa",
        "rareness": 2,
        "visitors": 12
      },
      {
        "id": "LV",
        "int_id": 127,
        "unp": "LV",
        "un": "LV",
        "name": "Latvia",
        "short_name": "Latvia",
        "rareness": 6,
        "visitors": 1592
      },
      {
        "id": "LI",
        "int_id": 132,
        "unp": "LI",
        "un": "LI",
        "name": "Liechtenstein",
        "short_name": "Liechtenstein",
        "rareness": 6,
        "visitors": 845
      },
      {
        "id": "LT",
        "int_id": 133,
        "unp": "LT",
        "un": "LT",
        "name": "Lithuania",
        "short_name": "Lithuania",
        "rareness": 6,
        "visitors": 1346
      },
      {
        "id": "LU",
        "int_id": 134,
        "unp": "LU",
        "un": "LU",
        "name": "Luxembourg",
        "short_name": "Luxembourg",
        "rareness": 7,
        "visitors": 1982
      },
      {
        "id": "MT",
        "int_id": 141,
        "unp": "MT",
        "un": "MT",
        "name": "Malta",
        "short_name": "Malta",
        "rareness": 6,
        "visitors": 1383
      },
      {
        "id": "MD",
        "int_id": 149,
        "unp": "MD",
        "un": "MD",
        "name": "Moldova",
        "short_name": "Moldova",
        "rareness": 5,
        "visitors": 365
      },
      {
        "id": "MC",
        "int_id": 150,
        "unp": "MC",
        "un": "MC",
        "name": "Monaco",
        "short_name": "Monaco",
        "rareness": 7,
        "visitors": 2512
      },
      {
        "id": "ME",
        "int_id": 152,
        "unp": "ME",
        "un": "ME",
        "name": "Montenegro",
        "short_name": "Montenegro",
        "rareness": 6,
        "visitors": 1521
      },
      {
        "id": "NL",
        "int_id": 160,
        "unp": "NL",
        "un": "NL",
        "name": "Netherlands",
        "short_name": "Netherlands",
        "rareness": 7,
        "visitors": 7254
      },
      {
        "id": "MK",
        "int_id": 168,
        "unp": "MK",
        "un": "MK",
        "name": "North Macedonia",
        "short_name": "North Macedonia",
        "rareness": 6,
        "visitors": 898
      },
      {
        "id": "NO",
        "int_id": 171,
        "unp": "NO",
        "un": "NO",
        "name": "Norway",
        "short_name": "Norway",
        "rareness": 7,
        "visitors": 2599
      },
      {
        "id": "PL",
        "int_id": 182,
        "unp": "PL",
        "un": "PL",
        "name": "Poland",
        "short_name": "Poland",
        "rareness": 7,
        "visitors": 4090
      },
      {
        "id": "PT:0",
        "int_id": 1300,
        "unp": "PT",
        "un": "PT",
        "name": "Portugal",
        "short_name": "Portugal",
        "rareness": 7,
        "visitors": 4862
      },
      {
        "id": "RO",
        "int_id": 187,
        "unp": "RO",
        "un": "RO",
        "name": "Romania",
        "short_name": "Romania",
        "rareness": 7,
        "visitors": 1772
      },
      {
        "id": "RU:E",
        "int_id": 1301,
        "unp": "RU",
        "un": "RU",
        "name": "Russia in Europe",
        "short_name": "Russia in Europe",
        "rareness": 7,
        "visitors": 2655
      },
      {
        "id": "SM",
        "int_id": 198,
        "unp": "SM",
        "un": "SM",
        "name": "San Marino",
        "short_name": "San Marino",
        "rareness": 6,
        "visitors": 870
      },
      {
        "id": "IT-88",
        "int_id": 350,
        "unp": "IT",
        "un": "IT",
        "name": "Sardinia",
        "short_name": "Sardinia",
        "rareness": 6,
        "visitors": 760
      },
      {
        "id": "GB-SCT",
        "int_id": 1302,
        "unp": "GB",
        "un": "GB",
        "name": "Scotland",
        "short_name": "Scotland",
        "rareness": 7,
        "visitors": 3532
      },
      {
        "id": "RS",
        "int_id": 202,
        "unp": "RS",
        "un": "RS",
        "name": "Serbia",
        "short_name": "Serbia",
        "rareness": 6,
        "visitors": 1687
      },
      {
        "id": "IT-82:1",
        "int_id": 1303,
        "unp": "IT",
        "un": "IT",
        "name": "Sicily",
        "short_name": "Sicily",
        "rareness": 6,
        "visitors": 1656
      },
      {
        "id": "SK",
        "int_id": 207,
        "unp": "SK",
        "un": "SK",
        "name": "Slovakia",
        "short_name": "Slovakia",
        "rareness": 7,
        "visitors": 2644
      },
      {
        "id": "SI",
        "int_id": 208,
        "unp": "SI",
        "un": "SI",
        "name": "Slovenia",
        "short_name": "Slovenia",
        "rareness": 7,
        "visitors": 2218
      },
      {
        "id": "ES:0",
        "int_id": 1304,
        "unp": "ES",
        "un": "ES",
        "name": "Spain",
        "short_name": "Spain",
        "rareness": 7,
        "visitors": 8579
      },
      {
        "id": "SJ",
        "int_id": 220,
        "unp": "SJ",
        "un": "NO",
        "name": "Spitsbergen (Svalbard, Bear Island)",
        "short_name": "Spitsbergen",
        "rareness": 4,
        "visitors": 83
      },
      {
        "id": "BA-SRP",
        "int_id": 1104,
        "unp": "BA",
        "un": "BA",
        "name": "Srpska",
        "short_name": "Srpska",
        "rareness": 5,
        "visitors": 439
      },
      {
        "id": "SE",
        "int_id": 221,
        "unp": "SE",
        "un": "SE",
        "name": "Sweden",
        "short_name": "Sweden",
        "rareness": 7,
        "visitors": 3851
      },
      {
        "id": "CH",
        "int_id": 222,
        "unp": "CH",
        "un": "CH",
        "name": "Switzerland",
        "short_name": "Switzerland",
        "rareness": 7,
        "visitors": 5478
      },
      {
        "id": "XT",
        "int_id": 232,
        "unp": "XT",
        "un": "MD",
        "name": "Transnistria (Pridnestrovie)",
        "short_name": "Transnistria",
        "rareness": 4,
        "visitors": 170
      },
      {
        "id": "TR:E",
        "int_id": 1305,
        "unp": "TR",
        "un": "TR",
        "name": "Turkey in Europe (Istanbul)",
        "short_name": "Turkey in Europe",
        "rareness": 7,
        "visitors": 3741
      },
      {
        "id": "UA",
        "int_id": 240,
        "unp": "UA",
        "un": "UA",
        "name": "Ukraine",
        "short_name": "Ukraine",
        "rareness": 6,
        "visitors": 1436
      },
      {
        "id": "VA",
        "int_id": 101,
        "unp": "VA",
        "un": "VA",
        "name": "Vatican City",
        "short_name": "Vatican City",
        "rareness": 7,
        "visitors": 3156
      },
      {
        "id": "GB-WLS",
        "int_id": 1306,
        "unp": "GB",
        "un": "GB",
        "name": "Wales",
        "short_name": "Wales",
        "rareness": 7,
        "visitors": 1756
      }
    ]
  },
  {
    "reg": "ANT",
    "region": "Antarctica",
    "total": 7,
    "db": [
      {
        "id": "AQ-AR",
        "int_id": 1307,
        "unp": "AQ",
        "un": "AQ",
        "name": "Argentine Antarctica (Antarctic Peninsula)",
        "short_name": "Argentine Antarctica",
        "rareness": 1,
        "visitors": 44
      },
      {
        "id": "AQ-AU",
        "int_id": 1308,
        "unp": "AQ",
        "un": "AQ",
        "name": "Australian Antarctic Territory (Davis, Heard, Macquarie, Mawson)",
        "short_name": "Australian Antarctic Territory",
        "rareness": 1,
        "visitors": 5
      },
      {
        "id": "AQ-GB",
        "int_id": 1309,
        "unp": "AQ",
        "un": "AQ",
        "name": "British Antarctic Territory (Antarctic Peninsula, Graham Land, South Orkney, South Shetland)",
        "short_name": "British Antarctic Territory",
        "rareness": 1,
        "visitors": 44
      },
      {
        "id": "AQ-CL",
        "int_id": 1310,
        "unp": "AQ",
        "un": "AQ",
        "name": "Chilean Antarctic Territory (Antarctic Peninsula)",
        "short_name": "Chilean Antarctic Territory",
        "rareness": 1,
        "visitors": 40
      },
      {
        "id": "AQ-FR",
        "int_id": 1311,
        "unp": "AQ",
        "un": "AQ",
        "name": "French Antarctica (Adélie, Kerguelen)",
        "short_name": "French Antarctica",
        "rareness": 1,
        "visitors": 3
      },
      {
        "id": "AQ-NZ",
        "int_id": 1312,
        "unp": "AQ",
        "un": "AQ",
        "name": "New Zealand Antarctica (Ross Dependency)",
        "short_name": "New Zealand Antarctica",
        "rareness": 1,
        "visitors": 5
      },
      {
        "id": "AQ-NO",
        "int_id": 1313,
        "unp": "AQ",
        "un": "AQ",
        "name": "Norwegian Dependencies (Bouvet, Peter I Island, Queen Maud Land)",
        "short_name": "Norwegian Dependencies (Bouvet, Peter I Island, Queen Maud Land)",
        "rareness": 1,
        "visitors": 1
      }
    ]
  },
  {
    "reg": "AFR",
    "region": "Africa",
    "total": 55,
    "db": [
      {
        "id": "DZ",
        "int_id": 6,
        "unp": "DZ",
        "un": "DZ",
        "name": "Algeria",
        "short_name": "Algeria",
        "rareness": 4,
        "visitors": 202
      },
      {
        "id": "AO",
        "int_id": 9,
        "unp": "AO",
        "un": "AO",
        "name": "Angola",
        "short_name": "Angola",
        "rareness": 4,
        "visitors": 86
      },
      {
        "id": "BJ",
        "int_id": 26,
        "unp": "BJ",
        "un": "BJ",
        "name": "Benin",
        "short_name": "Benin",
        "rareness": 3,
        "visitors": 49
      },
      {
        "id": "BW",
        "int_id": 32,
        "unp": "BW",
        "un": "BW",
        "name": "Botswana",
        "short_name": "Botswana",
        "rareness": 4,
        "visitors": 192
      },
      {
        "id": "BF",
        "int_id": 38,
        "unp": "BF",
        "un": "BF",
        "name": "Burkina Faso",
        "short_name": "Burkina Faso",
        "rareness": 2,
        "visitors": 32
      },
      {
        "id": "BI",
        "int_id": 39,
        "unp": "BI",
        "un": "BI",
        "name": "Burundi",
        "short_name": "Burundi",
        "rareness": 3,
        "visitors": 34
      },
      {
        "id": "AO-CAB",
        "int_id": 877,
        "unp": "AO",
        "un": "AO",
        "name": "Cabinda",
        "short_name": "Cabinda",
        "rareness": 1,
        "visitors": 6
      },
      {
        "id": "CM",
        "int_id": 42,
        "unp": "CM",
        "un": "CM",
        "name": "Cameroon",
        "short_name": "Cameroon",
        "rareness": 4,
        "visitors": 71
      },
      {
        "id": "CF",
        "int_id": 45,
        "unp": "CF",
        "un": "CF",
        "name": "Central African Republic",
        "short_name": "Central African Republic",
        "rareness": 2,
        "visitors": 17
      },
      {
        "id": "TD",
        "int_id": 46,
        "unp": "TD",
        "un": "TD",
        "name": "Chad",
        "short_name": "Chad",
        "rareness": 2,
        "visitors": 21
      },
      {
        "id": "CD",
        "int_id": 54,
        "unp": "CD",
        "un": "CD",
        "name": "Congo, Democratic Republic of (Kinshasa)",
        "short_name": "Congo",
        "rareness": 4,
        "visitors": 77
      },
      {
        "id": "CG",
        "int_id": 53,
        "unp": "CG",
        "un": "CG",
        "name": "Congo, Republic of (Brazzaville)",
        "short_name": "Congo",
        "rareness": 2,
        "visitors": 31
      },
      {
        "id": "CI",
        "int_id": 57,
        "unp": "CI",
        "un": "CI",
        "name": "Côte d’Ivoire (Ivory Coast)",
        "short_name": "Côte d’Ivoire",
        "rareness": 4,
        "visitors": 96
      },
      {
        "id": "DJ",
        "int_id": 64,
        "unp": "DJ",
        "un": "DJ",
        "name": "Djibouti",
        "short_name": "Djibouti",
        "rareness": 3,
        "visitors": 63
      },
      {
        "id": "EG:0",
        "int_id": 1314,
        "unp": "EG",
        "un": "EG",
        "name": "Egypt in Africa",
        "short_name": "Egypt in Africa",
        "rareness": 7,
        "visitors": 1963
      },
      {
        "id": "GQ-I",
        "int_id": 1117,
        "unp": "GQ",
        "un": "GQ",
        "name": "Equatorial Guinea (Bioko)",
        "short_name": "Equatorial Guinea (Bioko)",
        "rareness": 2,
        "visitors": 24
      },
      {
        "id": "GQ-C",
        "int_id": 1116,
        "unp": "GQ",
        "un": "GQ",
        "name": "Equatorial Guinea (Rio Muni)",
        "short_name": "Equatorial Guinea (Rio Muni)",
        "rareness": 2,
        "visitors": 10
      },
      {
        "id": "ER",
        "int_id": 71,
        "unp": "ER",
        "un": "ER",
        "name": "Eritrea",
        "short_name": "Eritrea",
        "rareness": 2,
        "visitors": 22
      },
      {
        "id": "SZ",
        "int_id": 73,
        "unp": "SZ",
        "un": "SZ",
        "name": "Eswatini (Swaziland)",
        "short_name": "Eswatini",
        "rareness": 4,
        "visitors": 97
      },
      {
        "id": "ET",
        "int_id": 74,
        "unp": "ET",
        "un": "ET",
        "name": "Ethiopia",
        "short_name": "Ethiopia",
        "rareness": 5,
        "visitors": 238
      },
      {
        "id": "GA",
        "int_id": 83,
        "unp": "GA",
        "un": "GA",
        "name": "Gabon",
        "short_name": "Gabon",
        "rareness": 3,
        "visitors": 39
      },
      {
        "id": "GM",
        "int_id": 84,
        "unp": "GM",
        "un": "GM",
        "name": "Gambia, The",
        "short_name": "Gambia",
        "rareness": 4,
        "visitors": 74
      },
      {
        "id": "GH",
        "int_id": 87,
        "unp": "GH",
        "un": "GH",
        "name": "Ghana",
        "short_name": "Ghana",
        "rareness": 4,
        "visitors": 176
      },
      {
        "id": "GN",
        "int_id": 96,
        "unp": "GN",
        "un": "GN",
        "name": "Guinea",
        "short_name": "Guinea",
        "rareness": 2,
        "visitors": 31
      },
      {
        "id": "GW",
        "int_id": 97,
        "unp": "GW",
        "un": "GW",
        "name": "Guinea-Bissau",
        "short_name": "Guinea-Bissau",
        "rareness": 2,
        "visitors": 21
      },
      {
        "id": "KE",
        "int_id": 119,
        "unp": "KE",
        "un": "KE",
        "name": "Kenya",
        "short_name": "Kenya",
        "rareness": 6,
        "visitors": 554
      },
      {
        "id": "LS",
        "int_id": 129,
        "unp": "LS",
        "un": "LS",
        "name": "Lesotho",
        "short_name": "Lesotho",
        "rareness": 4,
        "visitors": 80
      },
      {
        "id": "LR",
        "int_id": 130,
        "unp": "LR",
        "un": "LR",
        "name": "Liberia",
        "short_name": "Liberia",
        "rareness": 2,
        "visitors": 25
      },
      {
        "id": "LY",
        "int_id": 131,
        "unp": "LY",
        "un": "LY",
        "name": "Libya",
        "short_name": "Libya",
        "rareness": 4,
        "visitors": 79
      },
      {
        "id": "MW",
        "int_id": 137,
        "unp": "MW",
        "un": "MW",
        "name": "Malawi",
        "short_name": "Malawi",
        "rareness": 4,
        "visitors": 70
      },
      {
        "id": "ML",
        "int_id": 140,
        "unp": "ML",
        "un": "ML",
        "name": "Mali",
        "short_name": "Mali",
        "rareness": 3,
        "visitors": 50
      },
      {
        "id": "MR",
        "int_id": 144,
        "unp": "MR",
        "un": "MR",
        "name": "Mauritania",
        "short_name": "Mauritania",
        "rareness": 3,
        "visitors": 54
      },
      {
        "id": "MA:0",
        "int_id": 1315,
        "unp": "MA",
        "un": "MA",
        "name": "Morocco",
        "short_name": "Morocco",
        "rareness": 7,
        "visitors": 2005
      },
      {
        "id": "EA",
        "int_id": 1316,
        "unp": "ES",
        "un": "ES",
        "name": "Morocco, Spanish (Ceuta, Melilla)",
        "short_name": "Ceuta & Melilla",
        "rareness": 4,
        "visitors": 170
      },
      {
        "id": "MZ",
        "int_id": 155,
        "unp": "MZ",
        "un": "MZ",
        "name": "Mozambique",
        "short_name": "Mozambique",
        "rareness": 4,
        "visitors": 155
      },
      {
        "id": "NA",
        "int_id": 157,
        "unp": "NA",
        "un": "NA",
        "name": "Namibia",
        "short_name": "Namibia",
        "rareness": 5,
        "visitors": 225
      },
      {
        "id": "NE",
        "int_id": 164,
        "unp": "NE",
        "un": "NE",
        "name": "Niger",
        "short_name": "Niger",
        "rareness": 2,
        "visitors": 19
      },
      {
        "id": "NG",
        "int_id": 165,
        "unp": "NG",
        "un": "NG",
        "name": "Nigeria",
        "short_name": "Nigeria",
        "rareness": 4,
        "visitors": 186
      },
      {
        "id": "RW",
        "int_id": 189,
        "unp": "RW",
        "un": "RW",
        "name": "Rwanda",
        "short_name": "Rwanda",
        "rareness": 4,
        "visitors": 119
      },
      {
        "id": "ST",
        "int_id": 199,
        "unp": "ST",
        "un": "ST",
        "name": "Sao Tome & Principe",
        "short_name": "Sao Tome & Principe",
        "rareness": 3,
        "visitors": 38
      },
      {
        "id": "SN",
        "int_id": 201,
        "unp": "SN",
        "un": "SN",
        "name": "Senegal",
        "short_name": "Senegal",
        "rareness": 4,
        "visitors": 219
      },
      {
        "id": "SL",
        "int_id": 204,
        "unp": "SL",
        "un": "SL",
        "name": "Sierra Leone",
        "short_name": "Sierra Leone",
        "rareness": 3,
        "visitors": 39
      },
      {
        "id": "SO",
        "int_id": 210,
        "unp": "SO",
        "un": "SO",
        "name": "Somalia (Italian Somaliland)",
        "short_name": "Somalia",
        "rareness": 2,
        "visitors": 21
      },
      {
        "id": "XS",
        "int_id": 211,
        "unp": "XS",
        "un": "SO",
        "name": "Somaliland (British)",
        "short_name": "Somaliland",
        "rareness": 2,
        "visitors": 19
      },
      {
        "id": "ZA",
        "int_id": 212,
        "unp": "ZA",
        "un": "ZA",
        "name": "South Africa",
        "short_name": "South Africa",
        "rareness": 6,
        "visitors": 1176
      },
      {
        "id": "SS",
        "int_id": 215,
        "unp": "SS",
        "un": "SS",
        "name": "South Sudan",
        "short_name": "South Sudan",
        "rareness": 2,
        "visitors": 17
      },
      {
        "id": "SD",
        "int_id": 218,
        "unp": "SD",
        "un": "SD",
        "name": "Sudan",
        "short_name": "Sudan",
        "rareness": 3,
        "visitors": 66
      },
      {
        "id": "TZ:0",
        "int_id": 1317,
        "unp": "TZ",
        "un": "TZ",
        "name": "Tanzania",
        "short_name": "Tanzania",
        "rareness": 5,
        "visitors": 371
      },
      {
        "id": "TG",
        "int_id": 229,
        "unp": "TG",
        "un": "TG",
        "name": "Togo",
        "short_name": "Togo",
        "rareness": 3,
        "visitors": 60
      },
      {
        "id": "TN",
        "int_id": 234,
        "unp": "TN",
        "un": "TN",
        "name": "Tunisia",
        "short_name": "Tunisia",
        "rareness": 6,
        "visitors": 972
      },
      {
        "id": "UG",
        "int_id": 239,
        "unp": "UG",
        "un": "UG",
        "name": "Uganda",
        "short_name": "Uganda",
        "rareness": 4,
        "visitors": 167
      },
      {
        "id": "EH:0",
        "int_id": 1318,
        "unp": "EH",
        "un": "MA",
        "name": "Western Sahara",
        "short_name": "Western Sahara",
        "rareness": 3,
        "visitors": 49
      },
      {
        "id": "ZM",
        "int_id": 255,
        "unp": "ZM",
        "un": "ZM",
        "name": "Zambia",
        "short_name": "Zambia",
        "rareness": 4,
        "visitors": 183
      },
      {
        "id": "TZ-Z",
        "int_id": 902,
        "unp": "TZ",
        "un": "TZ",
        "name": "Zanzibar",
        "short_name": "Zanzibar",
        "rareness": 5,
        "visitors": 292
      },
      {
        "id": "ZW",
        "int_id": 256,
        "unp": "ZW",
        "un": "ZW",
        "name": "Zimbabwe",
        "short_name": "Zimbabwe",
        "rareness": 4,
        "visitors": 211
      }
    ]
  },
  {
    "reg": "MID",
    "region": "Middle East",
    "total": 21,
    "db": [
      {
        "id": "AE-AZ",
        "int_id": 1196,
        "unp": "AE",
        "un": "AE",
        "name": "Abu Dhabi",
        "short_name": "Abu Dhabi",
        "rareness": 6,
        "visitors": 1329
      },
      {
        "id": "AE-AJ",
        "int_id": 1197,
        "unp": "AE",
        "un": "AE",
        "name": "Ajman",
        "short_name": "Ajman",
        "rareness": 3,
        "visitors": 65
      },
      {
        "id": "BH",
        "int_id": 20,
        "unp": "BH",
        "un": "BH",
        "name": "Bahrain",
        "short_name": "Bahrain",
        "rareness": 5,
        "visitors": 368
      },
      {
        "id": "AE-DU",
        "int_id": 1198,
        "unp": "AE",
        "un": "AE",
        "name": "Dubai",
        "short_name": "Dubai",
        "rareness": 7,
        "visitors": 2504
      },
      {
        "id": "EG:S",
        "int_id": 1319,
        "unp": "EG",
        "un": "EG",
        "name": "Egypt in Asia (Sinai Peninsula)",
        "short_name": "Egypt in Asia",
        "rareness": 6,
        "visitors": 626
      },
      {
        "id": "AE-FU",
        "int_id": 1199,
        "unp": "AE",
        "un": "AE",
        "name": "Fujairah",
        "short_name": "Fujairah",
        "rareness": 4,
        "visitors": 183
      },
      {
        "id": "IR",
        "int_id": 108,
        "unp": "IR",
        "un": "IR",
        "name": "Iran",
        "short_name": "Iran",
        "rareness": 5,
        "visitors": 321
      },
      {
        "id": "IQ",
        "int_id": 109,
        "unp": "IQ",
        "un": "IQ",
        "name": "Iraq",
        "short_name": "Iraq",
        "rareness": 4,
        "visitors": 187
      },
      {
        "id": "IL",
        "int_id": 112,
        "unp": "IL",
        "un": "IL",
        "name": "Israel",
        "short_name": "Israel",
        "rareness": 6,
        "visitors": 1207
      },
      {
        "id": "JO",
        "int_id": 117,
        "unp": "JO",
        "un": "JO",
        "name": "Jordan",
        "short_name": "Jordan",
        "rareness": 6,
        "visitors": 740
      },
      {
        "id": "KW",
        "int_id": 124,
        "unp": "KW",
        "un": "KW",
        "name": "Kuwait",
        "short_name": "Kuwait",
        "rareness": 5,
        "visitors": 244
      },
      {
        "id": "LB",
        "int_id": 128,
        "unp": "LB",
        "un": "LB",
        "name": "Lebanon",
        "short_name": "Lebanon",
        "rareness": 5,
        "visitors": 382
      },
      {
        "id": "OM",
        "int_id": 172,
        "unp": "OM",
        "un": "OM",
        "name": "Oman",
        "short_name": "Oman",
        "rareness": 6,
        "visitors": 541
      },
      {
        "id": "PS",
        "int_id": 175,
        "unp": "PS",
        "un": "PS",
        "name": "Palestine",
        "short_name": "Palestine",
        "rareness": 5,
        "visitors": 439
      },
      {
        "id": "QA",
        "int_id": 185,
        "unp": "QA",
        "un": "QA",
        "name": "Qatar",
        "short_name": "Qatar",
        "rareness": 6,
        "visitors": 989
      },
      {
        "id": "AE-RK",
        "int_id": 1200,
        "unp": "AE",
        "un": "AE",
        "name": "Ras Al Khaimah",
        "short_name": "Ras Al Khaimah",
        "rareness": 4,
        "visitors": 169
      },
      {
        "id": "SA",
        "int_id": 200,
        "unp": "SA",
        "un": "SA",
        "name": "Saudi Arabia",
        "short_name": "Saudi Arabia",
        "rareness": 6,
        "visitors": 605
      },
      {
        "id": "AE-SH",
        "int_id": 1201,
        "unp": "AE",
        "un": "AE",
        "name": "Sharjah",
        "short_name": "Sharjah",
        "rareness": 5,
        "visitors": 367
      },
      {
        "id": "SY",
        "int_id": 223,
        "unp": "SY",
        "un": "SY",
        "name": "Syria",
        "short_name": "Syria",
        "rareness": 4,
        "visitors": 194
      },
      {
        "id": "AE-UQ",
        "int_id": 1202,
        "unp": "AE",
        "un": "AE",
        "name": "Umm Al Qaiwain",
        "short_name": "Umm Al Qaiwain",
        "rareness": 3,
        "visitors": 61
      },
      {
        "id": "YE:0",
        "int_id": 1320,
        "unp": "YE",
        "un": "YE",
        "name": "Yemen",
        "short_name": "Yemen",
        "rareness": 3,
        "visitors": 47
      }
    ]
  },
  {
    "reg": "IND",
    "region": "Indian Ocean",
    "total": 15,
    "db": [
      {
        "id": "IN-AN",
        "int_id": 624,
        "unp": "IN",
        "un": "IN",
        "name": "Andaman-Nicobar Islands",
        "short_name": "Andaman-Nicobar Islands",
        "rareness": 3,
        "visitors": 48
      },
      {
        "id": "IO",
        "int_id": 35,
        "unp": "IO",
        "un": "GB",
        "name": "British Indian Ocean Territory (Chagos Archipelago, Diego Garcia)",
        "short_name": "British Indian Ocean Territory",
        "rareness": 2,
        "visitors": 11
      },
      {
        "id": "CX",
        "int_id": 49,
        "unp": "CX",
        "un": "AU",
        "name": "Christmas Island",
        "short_name": "Christmas Island",
        "rareness": 1,
        "visitors": 6
      },
      {
        "id": "CC",
        "int_id": 50,
        "unp": "CC",
        "un": "AU",
        "name": "Cocos (Keeling) Islands",
        "short_name": "Cocos (Keeling) Islands",
        "rareness": 1,
        "visitors": 6
      },
      {
        "id": "KM",
        "int_id": 52,
        "unp": "KM",
        "un": "KM",
        "name": "Comoros (Anjouan, Grand Comoro, Moheli)",
        "short_name": "Comoros",
        "rareness": 2,
        "visitors": 22
      },
      {
        "id": "IN-LD",
        "int_id": 625,
        "unp": "IN",
        "un": "IN",
        "name": "Lakshadweep",
        "short_name": "Lakshadweep",
        "rareness": 1,
        "visitors": 7
      },
      {
        "id": "MG",
        "int_id": 136,
        "unp": "MG",
        "un": "MG",
        "name": "Madagascar",
        "short_name": "Madagascar",
        "rareness": 4,
        "visitors": 102
      },
      {
        "id": "MV",
        "int_id": 139,
        "unp": "MV",
        "un": "MV",
        "name": "Maldives",
        "short_name": "Maldives",
        "rareness": 5,
        "visitors": 406
      },
      {
        "id": "MU:0",
        "int_id": 886,
        "unp": "MU",
        "un": "MU",
        "name": "Mauritius & Dependencies (Agalega, St. Brandon)",
        "short_name": "Mauritius",
        "rareness": 5,
        "visitors": 325
      },
      {
        "id": "YT",
        "int_id": 146,
        "unp": "YT",
        "un": "FR",
        "name": "Mayotte (Dzaoudzi)",
        "short_name": "Mayotte",
        "rareness": 2,
        "visitors": 15
      },
      {
        "id": "RE",
        "int_id": 186,
        "unp": "RE",
        "un": "FR",
        "name": "Reunion",
        "short_name": "Reunion",
        "rareness": 4,
        "visitors": 114
      },
      {
        "id": "MU-RO",
        "int_id": 887,
        "unp": "MU",
        "un": "MU",
        "name": "Rodrigues Island",
        "short_name": "Rodrigues Island",
        "rareness": 1,
        "visitors": 7
      },
      {
        "id": "SC",
        "int_id": 203,
        "unp": "SC",
        "un": "SC",
        "name": "Seychelles",
        "short_name": "Seychelles",
        "rareness": 4,
        "visitors": 163
      },
      {
        "id": "YE-SU",
        "int_id": 854,
        "unp": "YE",
        "un": "YE",
        "name": "Socotra",
        "short_name": "Socotra",
        "rareness": 1,
        "visitors": 8
      },
      {
        "id": "SC2",
        "int_id": 1321,
        "unp": "SC",
        "un": "SC",
        "name": "Zil Elwannyen Sesel (Aldabra, Amirante Islands, Farquhar)",
        "short_name": "Zil Elwannyen Sesel",
        "rareness": 1,
        "visitors": 1
      }
    ]
  },
  {
    "reg": "ASI",
    "region": "Asia",
    "total": 52,
    "db": [
      {
        "id": "XA",
        "int_id": 1,
        "unp": "XA",
        "un": "GE",
        "name": "Abkhazia",
        "short_name": "Abkhazia",
        "rareness": 5,
        "visitors": 318
      },
      {
        "id": "AF",
        "int_id": 2,
        "unp": "AF",
        "un": "AF",
        "name": "Afghanistan",
        "short_name": "Afghanistan",
        "rareness": 4,
        "visitors": 91
      },
      {
        "id": "AM",
        "int_id": 14,
        "unp": "AM",
        "un": "AM",
        "name": "Armenia",
        "short_name": "Armenia",
        "rareness": 6,
        "visitors": 621
      },
      {
        "id": "AZ",
        "int_id": 18,
        "unp": "AZ",
        "un": "AZ",
        "name": "Azerbaijan",
        "short_name": "Azerbaijan",
        "rareness": 6,
        "visitors": 476
      },
      {
        "id": "BD",
        "int_id": 21,
        "unp": "BD",
        "un": "BD",
        "name": "Bangladesh",
        "short_name": "Bangladesh",
        "rareness": 4,
        "visitors": 190
      },
      {
        "id": "BT",
        "int_id": 28,
        "unp": "BT",
        "un": "BT",
        "name": "Bhutan",
        "short_name": "Bhutan",
        "rareness": 4,
        "visitors": 83
      },
      {
        "id": "BN",
        "int_id": 36,
        "unp": "BN",
        "un": "BN",
        "name": "Brunei",
        "short_name": "Brunei",
        "rareness": 4,
        "visitors": 180
      },
      {
        "id": "KH",
        "int_id": 41,
        "unp": "KH",
        "un": "KH",
        "name": "Cambodia",
        "short_name": "Cambodia",
        "rareness": 6,
        "visitors": 1019
      },
      {
        "id": "CN:0",
        "int_id": 1322,
        "unp": "CN",
        "un": "CN",
        "name": "China, People’s Republic",
        "short_name": "China",
        "rareness": 7,
        "visitors": 2848
      },
      {
        "id": "GE",
        "int_id": 85,
        "unp": "GE",
        "un": "GE",
        "name": "Georgia",
        "short_name": "Georgia",
        "rareness": 6,
        "visitors": 1072
      },
      {
        "id": "CN-HI",
        "int_id": 673,
        "unp": "CN",
        "un": "CN",
        "name": "Hainan Island",
        "short_name": "Hainan Island",
        "rareness": 5,
        "visitors": 276
      },
      {
        "id": "HK",
        "int_id": 103,
        "unp": "HK",
        "un": "CN",
        "name": "Hong Kong",
        "short_name": "Hong Kong",
        "rareness": 7,
        "visitors": 2297
      },
      {
        "id": "IN:0",
        "int_id": 1323,
        "unp": "IN",
        "un": "IN",
        "name": "India",
        "short_name": "India",
        "rareness": 7,
        "visitors": 2045
      },
      {
        "id": "ID-JW",
        "int_id": 977,
        "unp": "ID",
        "un": "ID",
        "name": "Indonesia (Java)",
        "short_name": "Indonesia",
        "rareness": 6,
        "visitors": 819
      },
      {
        "id": "JP:0",
        "int_id": 1324,
        "unp": "JP",
        "un": "JP",
        "name": "Japan",
        "short_name": "Japan",
        "rareness": 7,
        "visitors": 3041
      },
      {
        "id": "KR-49",
        "int_id": 1086,
        "unp": "KR",
        "un": "KR",
        "name": "Jeju Island (South Korea)",
        "short_name": "Jeju Island",
        "rareness": 5,
        "visitors": 319
      },
      {
        "id": "ID-KA",
        "int_id": 978,
        "unp": "ID",
        "un": "ID",
        "name": "Kalimantan (Indonesian Borneo)",
        "short_name": "Kalimantan",
        "rareness": 4,
        "visitors": 86
      },
      {
        "id": "XJ",
        "int_id": 1325,
        "unp": "ZZ",
        "un": "ZZ",
        "name": "Kashmir",
        "short_name": "Kashmir",
        "rareness": 5,
        "visitors": 244
      },
      {
        "id": "KZ",
        "int_id": 118,
        "unp": "KZ",
        "un": "KZ",
        "name": "Kazakhstan",
        "short_name": "Kazakhstan",
        "rareness": 6,
        "visitors": 629
      },
      {
        "id": "KP",
        "int_id": 121,
        "unp": "KP",
        "un": "KP",
        "name": "Korea, North",
        "short_name": "North Korea",
        "rareness": 3,
        "visitors": 60
      },
      {
        "id": "KR:0",
        "int_id": 1326,
        "unp": "KR",
        "un": "KR",
        "name": "Korea, South",
        "short_name": "South Korea",
        "rareness": 7,
        "visitors": 1819
      },
      {
        "id": "KG",
        "int_id": 125,
        "unp": "KG",
        "un": "KG",
        "name": "Kyrgyzstan",
        "short_name": "Kyrgyzstan",
        "rareness": 5,
        "visitors": 339
      },
      {
        "id": "LA",
        "int_id": 126,
        "unp": "LA",
        "un": "LA",
        "name": "Laos",
        "short_name": "Laos",
        "rareness": 5,
        "visitors": 424
      },
      {
        "id": "ID-NU",
        "int_id": 1327,
        "unp": "ID",
        "un": "ID",
        "name": "Lesser Sunda Islands (Bali, Timor, Indonesia)",
        "short_name": "Lesser Sunda Islands",
        "rareness": 6,
        "visitors": 1385
      },
      {
        "id": "MO",
        "int_id": 135,
        "unp": "MO",
        "un": "CN",
        "name": "Macau",
        "short_name": "Macau",
        "rareness": 6,
        "visitors": 862
      },
      {
        "id": "MY:0",
        "int_id": 1328,
        "unp": "MY",
        "un": "MY",
        "name": "Malaysia",
        "short_name": "Malaysia",
        "rareness": 7,
        "visitors": 2047
      },
      {
        "id": "ID-ML",
        "int_id": 1329,
        "unp": "ID",
        "un": "ID",
        "name": "Maluku Islands",
        "short_name": "Maluku Islands",
        "rareness": 2,
        "visitors": 28
      },
      {
        "id": "MN",
        "int_id": 151,
        "unp": "MN",
        "un": "MN",
        "name": "Mongolia, Republic",
        "short_name": "Mongolia, Republic",
        "rareness": 4,
        "visitors": 184
      },
      {
        "id": "MM",
        "int_id": 156,
        "unp": "MM",
        "un": "MM",
        "name": "Myanmar (Burma)",
        "short_name": "Myanmar",
        "rareness": 5,
        "visitors": 351
      },
      {
        "id": "AZ-NX",
        "int_id": 1330,
        "unp": "AZ",
        "un": "AZ",
        "name": "Nakhchivan",
        "short_name": "Nakhchivan",
        "rareness": 2,
        "visitors": 15
      },
      {
        "id": "NP",
        "int_id": 159,
        "unp": "NP",
        "un": "NP",
        "name": "Nepal",
        "short_name": "Nepal",
        "rareness": 5,
        "visitors": 446
      },
      {
        "id": "PK:0",
        "int_id": 1331,
        "unp": "PK",
        "un": "PK",
        "name": "Pakistan",
        "short_name": "Pakistan",
        "rareness": 5,
        "visitors": 246
      },
      {
        "id": "ID-PP",
        "int_id": 986,
        "unp": "ID",
        "un": "ID",
        "name": "Papua (Irian Jaya)",
        "short_name": "Papua",
        "rareness": 2,
        "visitors": 27
      },
      {
        "id": "PH",
        "int_id": 180,
        "unp": "PH",
        "un": "PH",
        "name": "Philippines",
        "short_name": "Philippines",
        "rareness": 6,
        "visitors": 1055
      },
      {
        "id": "RU:A",
        "int_id": 1332,
        "unp": "RU",
        "un": "RU",
        "name": "Russia in Asia (incl. Siberia)",
        "short_name": "Russia in Asia",
        "rareness": 6,
        "visitors": 850
      },
      {
        "id": "MY:SA",
        "int_id": 1124,
        "unp": "MY",
        "un": "MY",
        "name": "Sabah (North Borneo)",
        "short_name": "Sabah",
        "rareness": 5,
        "visitors": 274
      },
      {
        "id": "MY-13",
        "int_id": 1125,
        "unp": "MY",
        "un": "MY",
        "name": "Sarawak",
        "short_name": "Sarawak",
        "rareness": 4,
        "visitors": 195
      },
      {
        "id": "IN-SK",
        "int_id": 594,
        "unp": "IN",
        "un": "IN",
        "name": "Sikkim",
        "short_name": "Sikkim",
        "rareness": 4,
        "visitors": 90
      },
      {
        "id": "SG",
        "int_id": 205,
        "unp": "SG",
        "un": "SG",
        "name": "Singapore",
        "short_name": "Singapore",
        "rareness": 7,
        "visitors": 2647
      },
      {
        "id": "XO",
        "int_id": 214,
        "unp": "XO",
        "un": "GE",
        "name": "South Ossetia",
        "short_name": "South Ossetia",
        "rareness": 2,
        "visitors": 28
      },
      {
        "id": "LK",
        "int_id": 217,
        "unp": "LK",
        "un": "LK",
        "name": "Sri Lanka (Ceylon)",
        "short_name": "Sri Lanka",
        "rareness": 6,
        "visitors": 649
      },
      {
        "id": "ID-SL",
        "int_id": 979,
        "unp": "ID",
        "un": "ID",
        "name": "Sulawesi (Celebes, Indonesia)",
        "short_name": "Sulawesi",
        "rareness": 4,
        "visitors": 103
      },
      {
        "id": "ID-SM",
        "int_id": 980,
        "unp": "ID",
        "un": "ID",
        "name": "Sumatra (Indonesia)",
        "short_name": "Sumatra",
        "rareness": 5,
        "visitors": 379
      },
      {
        "id": "TW",
        "int_id": 224,
        "unp": "TW",
        "un": "CN",
        "name": "Taiwan. R.O.C.",
        "short_name": "Taiwan",
        "rareness": 6,
        "visitors": 1239
      },
      {
        "id": "TJ",
        "int_id": 225,
        "unp": "TJ",
        "un": "TJ",
        "name": "Tajikistan",
        "short_name": "Tajikistan",
        "rareness": 4,
        "visitors": 147
      },
      {
        "id": "TH",
        "int_id": 227,
        "unp": "TH",
        "un": "TH",
        "name": "Thailand",
        "short_name": "Thailand",
        "rareness": 7,
        "visitors": 3158
      },
      {
        "id": "CN-XZ",
        "int_id": 644,
        "unp": "CN",
        "un": "CN",
        "name": "Tibet",
        "short_name": "Tibet",
        "rareness": 4,
        "visitors": 92
      },
      {
        "id": "TL",
        "int_id": 228,
        "unp": "TL",
        "un": "TL",
        "name": "Timor-Leste",
        "short_name": "Timor-Leste",
        "rareness": 3,
        "visitors": 43
      },
      {
        "id": "TR:A",
        "int_id": 1333,
        "unp": "TR",
        "un": "TR",
        "name": "Turkey in Asia (Anatolia, Ankara, Izmir)",
        "short_name": "Turkey in Asia",
        "rareness": 7,
        "visitors": 3261
      },
      {
        "id": "TM",
        "int_id": 236,
        "unp": "TM",
        "un": "TM",
        "name": "Turkmenistan",
        "short_name": "Turkmenistan",
        "rareness": 4,
        "visitors": 71
      },
      {
        "id": "UZ",
        "int_id": 246,
        "unp": "UZ",
        "un": "UZ",
        "name": "Uzbekistan",
        "short_name": "Uzbekistan",
        "rareness": 5,
        "visitors": 429
      },
      {
        "id": "VN",
        "int_id": 249,
        "unp": "VN",
        "un": "VN",
        "name": "Vietnam",
        "short_name": "Vietnam",
        "rareness": 6,
        "visitors": 1741
      }
    ]
  }
];
